import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { SubmissionError } from 'redux-form';
import ResetForm from 'login/components/password_reset_form';
import { resetPasswordRequest } from 'common/ducks/user';
import LoginImg from 'assets/images/login-bg.jpg';

/**
 * Password reset screen.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
export default class PasswordReset extends Component {
  constructor(props) {
    super(props)

    this.state = {done: false}
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit(data) {
    const { uid, key } = this.props.params
    return resetPasswordRequest({...data, key, uid })
      .then(() => this.setState({done: true}))
      .catch((res) => {
        throw new SubmissionError({
          _error: res.status == 404?
            'Invalid link. Maybe it expired?':  // no valid request to reset password was found
            'Unknown error. Please try again.'
        })
      })
  }

  render() {
    return (
      <div id="content" className="l-content password-reset">
        <div className="row">
          {this.state.done?
          <div className="done columns small-16 medium-6">
            <h2><i className="fa fa-check-circle"/><br/> Password Changed</h2>
            <p>Please login.</p>
            <Link to='/login/' rel="nofollow" className="btn btn-primary">Login</Link>
          </div>:
          <div className="columns small-16 medium-6">
            <h3>Welcome back.</h3>
            <p>Enter your new password below.</p>
            <ResetForm onSubmit={this.handleSubmit}/>
          </div>}

          <div className="columns hide-for-small-only medium-6 medium-offset-4">
            <img src={LoginImg}/>
          </div>
        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./login/components/password_reset.jsx